import { usePageMeta } from "@/lib/meta";
import { HtmlBlock } from "@/components/HtmlBlock";
import html from "@/gen/founder";

export default function FounderPage() {
  usePageMeta("The Founder");
  return <HtmlBlock html={html} testId="founder-page" />;
}
